import { BrowserRouter, Route, Switch } from 'react-router-dom';

export const MiniAppRouter = ({ children }: { children: React.ReactNode }) => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/">
          {children}
        </Route>
        <Route path="/:pagePath">{children}</Route>
      </Switch>
    </BrowserRouter>
  );
};
